import { LoginResponse } from "./LoginResponse";

export abstract class Login {
  static LOGGED_USER_KEY = "loggedUserId";
  public abstract doLogin(mail: string, password: string, captchaToken: string): Promise<LoginResponse>;

  public abstract restoreSession(): Promise<LoginResponse>;

  public abstract doLogout(): Promise<boolean>;
}
